import { NgModule } from '@angular/core';

import { FuseHighlightComponent } from '@fuzz/components/highlight/highlight.component';

@NgModule({
    declarations: [
        FuseHighlightComponent
    ],
    exports: [
        FuseHighlightComponent
    ],
})
export class FuseHighlightModule
{
}
